import { render, staticRenderFns } from "./settlementListDriver.vue?vue&type=template&id=37a159d3"
import script from "./settlementListDriver.vue?vue&type=script&lang=js"
export * from "./settlementListDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports